import Spinner from '@creator/ui/components/Spinner/Spinner';
import { cn } from '@creator/ui/utils/ui';
import AdvertisingSlot from '@src/components/Ads/AdvertisingSlot';
import PostView from '@src/components/Post/PostView/PostView';
import TokenSidebar from '@src/components/Token/TokenSidebar/TokenSidebar';
import usePageTitle from '@src/hooks/usePageTitle';
import { useStoreActions } from '@src/model/hooks';
import { isResponsePost } from '@src/model/upvote/helpers';
import { getUserId } from '@src/model/user/helpers';
import { usePost } from '@src/store/posts/hooks/usePost';
import { usePostLoader } from '@src/store/posts/hooks/usePostLoader';
import { postView } from '@src/store/posts/view';
import React, { type FC, useEffect, memo, Fragment } from 'react';
import BottomStickyAd from '../BottomStickyAd';
export interface PostTabProps {
    tokenName: string;
    identifier: string;
    commentId?: string;
    replyId?: string;
    className?: string;
}

const PostTab: FC<PostTabProps> = props => {
    const { tokenName, identifier = '', commentId = '', replyId = '', className = '' } = props;

    const loadResponse = useStoreActions(actions => actions.response.loadResponse);
    const { load, loadStatus, postId } = usePostLoader({ identifier });
    const post = usePost(postId);

    usePageTitle(getPageTitle());

    function getPageTitle() {
        if (!post) return '';
        if (post.createdByWhitelistedUser) return post.title;
        return `${post.title} - Community Post`;
    }

    useEffect(() => {
        if (!postId) return;
        postView({ postId, tokenName, userId: getUserId() });
        console.log(`[PostTab] postId: ${postId}`);
    }, [postId]);

    useEffect(() => {
        if (!identifier) return;
        loadContent();
    }, [identifier]);

    async function loadContent() {
        const post = await load();
        if (!post || !isResponsePost(post)) return;
        loadResponse(post.id);
    }

    function renderPost() {
        if (!postId) return null;
        return <PostView showRecommendedPostList={true} loadCommentId={commentId} loadReplyId={replyId} tokenName={tokenName} className="" postId={postId} />;
    }

    function renderSpinner() {
        if (loadStatus !== 'loading' || post) return null;
        return <Spinner className="mx-auto mt-8" />;
    }

    return (
        <Fragment>
            <div className={cn('space-y-4 pb-4', className)}>
                <AdvertisingSlot location="top_center" tokenName={tokenName} />
                <div className="container flex lg:space-x-4">
                    <div className="hidden xl:block xl:w-1/12" />
                    <div className="w-full lg:w-8/12 xl:w-7/12">
                        {renderPost()}
                        {renderSpinner()}
                    </div>
                    <div className="hidden lg:flex lg:w-4/12 xl:w-3/12">
                        <TokenSidebar tokenName={tokenName} />
                    </div>
                    <div className="hidden xl:block xl:w-1/12" />
                </div>
            </div>
            <BottomStickyAd tokenName={tokenName} />
        </Fragment>
    );
};

export default memo(PostTab);
